import * as PROJECT_CODE from '../../constants/projectCode';
import firebase from '../../lib/firebase.prod';

export async function editUser(
	userId,
	firstName,
	lastName,
	email,
	phoneNumber,
	projectsList
) {
	try {
		if (userId) {
			let updateUserAccount = firebase
				.functions()
				.httpsCallable('updateUserAccount');
			await updateUserAccount({
				id: userId,
				firstName: firstName + ' ' + lastName,
				phoneNumber: phoneNumber,
				email: email,
			});

			let projectListKeys = Object.keys(projectsList);
			let projectListObj = {};
			projectListKeys.forEach((key) => {
				var projectDetails = projectsList[key];

				projectListObj = {
					...projectListObj,
					[projectDetails.key]: projectDetails.role,
				};
			});

			let user = firebase.database().ref('/users/' + userId);
			await user.update({
				email: email,
				phoneNumber: phoneNumber,
				fullName: firstName + ' ' + lastName,
				displayName: firstName + ' ' + lastName,
				projectRoles: projectListObj,
			});
		}
	} catch (error) {
		throw error;
	}
}
